import React, {useState} from 'react';
import {Layout, Dropdown, Avatar, Button, Space, Typography, Drawer} from 'antd';
import {
    LogoutOutlined,
    UserOutlined,
    MenuOutlined,
    DashboardOutlined
} from '@ant-design/icons';
import './header.module.css';

const {Header: AntHeader} = Layout;
const {Text, Title} = Typography;

const Header = ({exit, user, isLogoutLoader}) => {
    const [drawerVisible, setDrawerVisible] = useState(false);

    // Создаем меню для Dropdown
    const menuItems = [
        {
            key: '1',
            label: (
                <div style={{padding: '4px 12px'}}>
                    <Text strong style={{color: '#f0f0f0'}}>Вы вошли как:</Text>
                    <div style={{marginTop: '4px', color: '#69b1ff'}}>
                        {user?.login || 'Пользователь'}
                    </div>
                </div>
            ),
        },
        {
            type: 'divider',
        },
        {
            key: '2',
            label: (
                <Space onClick={exit} style={{padding: '4px 12px', width: '100%'}}>
                    <LogoutOutlined/>
                    <span>Выйти</span>
                </Space>
            ),
        },
    ];

    return (
        <>
            <AntHeader
                style={{
                    padding: '0 24px',
                    background: '#141414',
                    borderBottom: '1px solid #303030',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    zIndex: 10,
                    position: 'sticky',
                    top: 0,
                    height: '64px'
                }}
            >
                {/* Логотип и название приложения */}
                <Space>
                    <DashboardOutlined style={{fontSize: '20px', color: '#52c41a'}}/>
                    <Title level={4} style={{color: '#f0f0f0', margin: 0, fontSize: '18px'}}>
                        Garden Design APP
                    </Title>
                </Space>

                {/* Блок пользователя для десктопов */}
                <Space className="desktop-user-menu">
                    <Dropdown
                        menu={{items: menuItems}}
                        trigger={['click']}
                        placement="bottomRight"
                        overlayStyle={{width: '200px', background: '#1f1f1f'}}
                    >
                        <Button type="text" style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#f0f0f0',
                            height: '40px'
                        }}>
                            <Avatar
                                size="default"
                                icon={<UserOutlined/>}
                                style={{
                                    backgroundColor: '#52c41a',
                                    marginRight: '8px'
                                }}
                            />
                            <Text style={{color: '#f0f0f0'}}>
                                {user?.login || 'Пользователь'}
                            </Text>
                        </Button>
                    </Dropdown>
                </Space>

                {/* Кнопка меню для мобильных устройств */}
                <Button
                    type="text"
                    icon={<MenuOutlined style={{color: '#f0f0f0', fontSize: '18px'}}/>}
                    className="mobile-menu-btn"
                    onClick={() => setDrawerVisible(true)}
                />
            </AntHeader>

            {/* Выдвижная панель для мобильных устройств */}
            <Drawer
                title="Меню пользователя"
                placement="right"
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
                styles={{
                    header: {
                        background: '#141414',
                        borderBottom: '1px solid #303030',
                        color: '#f0f0f0'
                    },
                    body: {
                        padding: 0,
                        background: '#1f1f1f',
                        color: '#f0f0f0'
                    },
                    wrapper: {
                        width: '280px'
                    }
                }}
            >
                <div style={{padding: '16px'}}>
                    <Space direction="vertical" style={{width: '100%'}}>
                        <Space direction="vertical" style={{width: '100%', marginBottom: '16px'}}>
                            <Text strong style={{color: '#f0f0f0'}}>Вы вошли как:</Text>
                            <Text style={{color: '#69b1ff'}}>{user?.login || 'Пользователь'}</Text>
                        </Space>

                        <Button
                            block
                            loading={isLogoutLoader}
                            icon={<LogoutOutlined/>}
                            onClick={exit}
                            style={{
                                height: '40px',
                                background: '#52c41a',
                                border: 'none',
                                color: '#fff',
                                fontWeight: '500'
                            }}
                        >
                            Выйти
                        </Button>
                    </Space>
                </div>
            </Drawer>
        </>
    );
};

export default Header;